

import * as THREE from "../../libs/three.js/build/three.module.js";
import { ClipVolume } from "./ClipVolume.js";
import { PolygonClipVolume } from "./PolygonClipVolume.js";
import { EventDispatcher } from "../EventDispatcher.js";
import { unref } from "vue";
import { Points } from "../Points.js";
import { LASExporter } from "../exporter/LASExporter.js";
import { PointCloudTree } from "../PointCloudTree.js";
import { PointCloudMaterial } from "../materials/PointCloudMaterial.js";
import { PointSizeType, ClipTask } from "../defines.js";
import { PointCloudOctreeGeometryNode } from "@/PointCloudOctreeGeometry";
import { PointCloudOctreeNode } from "@/PointCloudOctree";
import { Utils } from "@/utils";
import { collapseItemProps } from "element-plus";

export class ClippingTool extends EventDispatcher {

	constructor(viewer) {
		super();

		this.viewer = viewer;
		this.waitingSelection = false;
		this.inClipping = false;
		this.hasClipVolume = false;
		this.maxPolygonVertices = 100;

		this.addEventListener("start_inserting_clipping_volume", e => {
			this.viewer.dispatchEvent({
				type: "cancel_insertions"
			});
		});

		this.sceneMarker = new THREE.Scene();
		this.sceneVolume = new THREE.Scene();
		this.sceneVolume.name = "scene_clip_volume";
		this.viewer.inputHandler.registerInteractiveScene(this.sceneVolume);

		this.onRemove = e => {
			this.sceneVolume.remove(e.volume);
			this.hasClipVolume = false;
			this.notify();
		};

		this.onAdd = e => {
			this.sceneVolume.add(e.volume);
			this.hasClipVolume = true;
			this.notify();
		};

		this.viewer.inputHandler.addEventListener("delete", e => {
			let volumes = e.selection.filter(e => (e instanceof ClipVolume));
			volumes.forEach(e => this.viewer.scene.removeClipVolume(e));
			let polyVolumes = e.selection.filter(e => (e instanceof PolygonClipVolume));
			polyVolumes.forEach(e => this.viewer.scene.removePolygonClipVolume(e));
		});
	}

	setScene(scene) {
		if (this.scene === scene) {
			return;
		}

		if (this.scene) {
			this.scene.removeEventListeners("clip_volume_added", this.onAdd);
			this.scene.removeEventListeners("clip_volume_removed", this.onRemove);
			this.scene.removeEventListeners("polygon_clip_volume_added", this.onAdd);
			this.scene.removeEventListeners("polygon_clip_volume_removed", this.onRemove);
		}

		this.scene = scene;

		this.scene.addEventListener("clip_volume_added", this.onAdd);
		this.scene.addEventListener("clip_volume_removed", this.onRemove);
		this.scene.addEventListener("polygon_clip_volume_added", this.onAdd);
		this.scene.addEventListener("polygon_clip_volume_removed", this.onRemove);
	}

	notify() {
		const data = {
			showTipSel: this.waitingSelection,
			showTipOpt: this.inClipping,
			showBtn: this.hasClipVolume
		};
		const event = new CustomEvent('onClippingUINotify', { detail: data });
		window.dispatchEvent(event);
	}

	startClipping(data) {
		console.log(data)
		//this.toClipPointCloud  = this.viewer.scene.pointclouds.find((obj: any) => obj.uuid === data.uuid);
		this.toClipPointCloud = this.scene.pointclouds.find(poc => poc.uuid === data.uuid);
		this.waitingSelection = false;
		this.inClipping = true;
		this.viewer.setClipTask(ClipTask.HIGHLIGHT);
		let clip = this.startInsertion({
			type: "polygon",
			name: 'cut_out',
		});
		this.notify();
		return clip
	}

	startSelectPointCloud() {
		if (this.waitingSelection) {
			this.waitingSelection = false;
			this.notify();
		} else {
			this.waitingSelection = true;
			this.inClipping = false;
			this.notify();
		}
	}

	cancelClipping() {
		this.waitingSelection = false;
		this.inClipping = false;
		this.notify();
		while (this.viewer.scene.polygonClipVolumes.length > 0) {
			this.viewer.scene.removePolygonClipVolume(this.viewer.scene.polygonClipVolumes[0]);
		}
		this.viewer.dispatchEvent({
			type: "cancel_insertions"
		});
	}

	pauseClipping(val) {
		console.log(val)
		const data = val;
		//const event = new CustomEvent('pause_insertions', { pause: data });
		//this.viewer.dispatchEvent(event);
		this.viewer.dispatchEvent({
			type: "pause_insertions",
			pause: val
		});
	}

	clearClipping() {
		while (this.viewer.scene.polygonClipVolumes.length > 0) {
			this.viewer.scene.removePolygonClipVolume(this.viewer.scene.polygonClipVolumes[0]);
		}
		this.waitingSelection = false;
		this.inClipping = true;
		this.viewer.setClipTask(ClipTask.HIGHLIGHT);
		let clip = this.startInsertion({
			type: "polygon",
			name: 'cut_out',
		});
		this.notify();
	}

	startInsertion(args = {}) {
		let type = args.type || null;

		if (!type) return null;

		let domElement = this.viewer.renderer.domElement;
		let canvasSize = this.viewer.renderer.getSize(new THREE.Vector2());

		let svg = $(`
		<svg height="${canvasSize.height}" width="${canvasSize.width}" style="position:absolute; pointer-events: none">

			<defs>
				 <marker id="diamond" markerWidth="24" markerHeight="24" refX="12" refY="12"
						markerUnits="userSpaceOnUse">
					<circle cx="12" cy="12" r="4" fill="white" stroke="black" stroke-width="2"/>
				</marker>
			</defs>

			<!-- <polygon fill="none" stroke="black" 
				style="stroke:rgb(0, 0, 0);
				stroke-width:2;"
				stroke-dasharray="9, 6"
				stroke-dashoffset="2"
				/> -->

			<polygon fill="none" stroke="black" 
				style="stroke:rgb(255, 255, 255);
				stroke-width:2;"
				stroke-dasharray="5, 10"
				marker-start="url(#diamond)" 
				marker-mid="url(#diamond)" 
				marker-end="url(#diamond)" 
				/>
		</svg>`);
		$(domElement.parentElement).append(svg);

		let polyClipVol = new PolygonClipVolume(this.viewer.scene.getActiveCamera().clone());
		polyClipVol.name = args.name || polyClipVol.name;

		this.dispatchEvent({ "type": "start_inserting_clipping_volume" });

		this.viewer.scene.addPolygonClipVolume(polyClipVol);
		this.sceneMarker.add(polyClipVol);

		let cancel = {
			callback: null
		};

		let pause = {
			callback: null
		}

		let clear = {
			callback: null
		}

		let insertionCallback = (e) => {
			if (e.button === THREE.MOUSE.LEFT) {

				polyClipVol.addMarker();

				// SVC Screen Line
				svg.find("polygon").each((index, target) => {
					let newPoint = svg[0].createSVGPoint();
					newPoint.x = e.offsetX;
					newPoint.y = e.offsetY;
					let polygon = target.points.appendItem(newPoint);
				});


				if (polyClipVol.markers.length > this.maxPolygonVertices) {
					cancel.callback();
				}

				this.viewer.inputHandler.startDragging(
					polyClipVol.markers[polyClipVol.markers.length - 1]);
			} else if (e.button === THREE.MOUSE.RIGHT) {
				cancel.callback(e);
			}
		};

		pause.callback = e => {
			polyClipVol.removeAllMarkers();

			console.log("omgomg pause ", e.pause)
			if (e.pause === true) {
				this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
				//svg.remove();
				svg.find("polygon").each((index, target) => {
					let newPoint = svg[0].createSVGPoint();

					let polyline = target.points.clear()
				});
				this.viewer.inputHandler.enabled = true;
			} else {
				//this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
				this.viewer.renderer.domElement.addEventListener("mouseup", insertionCallback, false);
				this.viewer.inputHandler.enabled = false;
			}
		}

		clear.callback = e => {
			svg.find("polygon").each((index, target) => {
				let newPoint = svg[0].createSVGPoint();
				let polyline = target.points.clear()
			});
			polyClipVol.removeAllMarkers();
		}

		cancel.callback = e => {

			//let first = svg.find("polyline")[0].points[0];
			//svg.find("polyline").each((index, target) => {
			//	let newPoint = svg[0].createSVGPoint();
			//	newPoint.x = first.x;
			//	newPoint.y = first.y;
			//	let polyline = target.points.appendItem(newPoint);
			//});
			svg.remove();

			if (polyClipVol.markers.length > 3) {
				polyClipVol.removeLastMarker();
				polyClipVol.initialized = true;
			} else {
				this.viewer.scene.removePolygonClipVolume(polyClipVol);
			}

			this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
			this.viewer.removeEventListener("cancel_insertions", cancel.callback);
			this.viewer.removeEventListener("pause_insertions", pause.callback);
			this.viewer.removeEventListener("clear_insertions", clear.callback);
			this.viewer.inputHandler.enabled = true;

			this.inClipping = false;
			this.notify();
		};

		this.viewer.addEventListener("cancel_insertions", cancel.callback);
		this.viewer.addEventListener("pause_insertions", pause.callback);
		this.viewer.addEventListener("clear_insertions", clear.callback);
		this.viewer.renderer.domElement.addEventListener("mouseup", insertionCallback, false);
		this.viewer.inputHandler.enabled = false;

		polyClipVol.addMarker();
		this.viewer.inputHandler.startDragging(
			polyClipVol.markers[polyClipVol.markers.length - 1]);

		return polyClipVol;
	}

	update() {

	}
};

export class CutFillTool extends EventDispatcher {

	constructor(viewer) {
		super();

		this.viewer = viewer;
		// notify params
		this.waitingSelection = false;
		this.inCutFill = false;
		this.hasCutFillVolume = false;
		this.isDone = false;

		this.maxPolygonVertices = 100;

		this.addEventListener("start_inserting_cut_fill_volume", e => {
			this.viewer.dispatchEvent({
				type: "cancel_insertions"
			});
		});

		this.sceneMarker = new THREE.Scene();
		this.sceneVolume = new THREE.Scene();
		this.sceneVolume.name = "scene_cut_fill_volume";
		this.viewer.inputHandler.registerInteractiveScene(this.sceneVolume);

		this.onRemove = e => {
			this.sceneVolume.remove(e.volume);
			this.hasCutFillVolume = false;
			this.isDone = false;
			this.notify();
		};

		this.onAdd = e => {
			this.sceneVolume.add(e.volume);
			this.hasCutFillVolume = true;
			this.notify();
		};

		this.viewer.inputHandler.addEventListener("delete", e => {
			let volumes = e.selection.filter(e => (e instanceof ClipVolume));
			volumes.forEach(e => this.viewer.scene.removeClipVolume(e));
			let polyVolumes = e.selection.filter(e => (e instanceof PolygonClipVolume));
			polyVolumes.forEach(e => this.viewer.scene.removePolygonCutFillVolume(e));
		});
	}

	setScene(scene) {
		if (this.scene === scene) {
			return;
		}

		if (this.scene) {
			this.scene.removeEventListeners("polygon_cut_fill_volume_added", this.onAdd);
			this.scene.removeEventListeners("polygon_cut_fill_volume_removed", this.onRemove);
		}

		this.scene = scene;

		this.scene.addEventListener("polygon_cut_fill_volume_added", this.onAdd);
		this.scene.addEventListener("polygon_cut_fill_volume_removed", this.onRemove);
	}

	reset() {
		this.waitingSelection = false;
		this.inCutFill = false;
		this.hasCutFillVolume = false;
		this.isDone = false;
	}

	notify() {
		const data = {
			showTipSel: this.waitingSelection,
			showTipOpt: this.inCutFill,
			//showBtn: this.hasCutFillVolume
			showPanel: this.hasCutFillVolume,
			isDone: this.isDone,
		}

		const event = new CustomEvent('onCutFillUINotify', { detail: data });
		window.dispatchEvent(event);
	}

	startCutFill(data) {
		console.log(data)
		//this.toClipPointCloud  = this.viewer.scene.pointclouds.find((obj: any) => obj.uuid === data.uuid);
		this.toClipPointCloud = this.scene.pointclouds.find(poc => poc.uuid === data.uuid);
		this.waitingSelection = false;
		this.inCutFill = true;
		this.viewer.setClipTask(ClipTask.HIGHLIGHT);
		let clip = this.startInsertion({
			type: "polygon",
			name: 'cut_out',
		});
		this.notify();
	}

	startSelectPointCloud() {
		this.viewer.setTopView();
		// this.viewer.fitToScreen();
		this.reset();

		if (this.waitingSelection) {
			this.waitingSelection = false;
			this.notify();
		} else {
			this.waitingSelection = true;
			this.inCutFill = false;
			this.notify();
		}
	}

	cancelCutFill() {
		while (this.viewer.scene.polygonClipVolumes.length > 0) {
			this.viewer.scene.removePolygonCutFillVolume(this.viewer.scene.polygonClipVolumes[0]);
		}
		this.waitingSelection = false;
		this.inCutFill = false;
		this.notify();
	}

	pauseCutFill(val) {
		console.log(val)
		const data = val;
		//const event = new CustomEvent('pause_insertions', { pause: data });
		//this.viewer.dispatchEvent(event);
		this.viewer.dispatchEvent({
			type: "pause_insertions",
			pause: val
		});
	}

	clearCutFill() {
		this.viewer.dispatchEvent({
			type: "clear_insertions"
		});
	}

	startInsertion(args = {}) {
		let type = args.type || null;

		if (!type) return null;
		//this.viewer.setTopView();

		// todo
		// if (this.viewer.scene.pointclouds.length > 0) {
		// 	this.toClipPointCloud = this.viewer.scene.pointclouds[0]
		// }

		let domElement = this.viewer.renderer.domElement;
		let canvasSize = this.viewer.renderer.getSize(new THREE.Vector2());

		let svg = $(`
		<svg height="${canvasSize.height}" width="${canvasSize.width}" style="position:absolute; pointer-events: none">

			<defs>
				 <marker id="diamond" markerWidth="24" markerHeight="24" refX="12" refY="12"
						markerUnits="userSpaceOnUse">
					<circle cx="12" cy="12" r="4" fill="white" stroke="black" stroke-width="2"/>
				</marker>
			</defs>

			<!-- <polyline fill="none" stroke="black" 
				style="stroke:rgb(0, 0, 0);
				stroke-width:6;"
				stroke-dasharray="9, 6"
				stroke-dashoffset="2"
				/> -->

			<polygon fill="none" stroke="black" 
				style="stroke:rgb(255, 255, 255);
				stroke-width:2;"
				stroke-dasharray="5, 10"
				marker-start="url(#diamond)" 
				marker-mid="url(#diamond)" 
				marker-end="url(#diamond)" 
				/>
		</svg>`);
		$(domElement.parentElement).append(svg);

		let polyClipVol = new PolygonClipVolume(this.viewer.scene.getActiveCamera().clone());
		polyClipVol.name = args.name || polyClipVol.name;
		this.dispatchEvent({ "type": "start_inserting_cut_fill_volume" });

		this.viewer.scene.addPolygonCutFillVolume(polyClipVol);
		this.sceneMarker.add(polyClipVol);

		let cancel = {
			callback: null
		};

		let pause = {
			callback: null
		}

		let clear = {
			callback: null
		}

		let insertionCallback = (e) => {
			if (e.button === THREE.MOUSE.LEFT) {
				// 第一个点开始锁定zoom
				//this.viewer.inputHandler.enabled = false;
				polyClipVol.addMarker();

				// SVC Screen Line
				svg.find("polygon").each((index, target) => {
					let newPoint = svg[0].createSVGPoint();
					newPoint.x = e.offsetX;
					newPoint.y = e.offsetY;
					let polyline = target.points.appendItem(newPoint);
				});


				if (polyClipVol.markers.length > this.maxPolygonVertices) {
					cancel.callback();
				}

				this.viewer.inputHandler.startDragging(
					polyClipVol.markers[polyClipVol.markers.length - 1]);
			} else if (e.button === THREE.MOUSE.RIGHT) {
				//this.viewer.setDescription('');
				cancel.callback(e);
			}
		};

		pause.callback = e => {
			polyClipVol.removeAllMarkers();

			if (e.pause === true) {
				this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
				//svg.remove();
				svg.find("polygon").each((index, target) => {
					let newPoint = svg[0].createSVGPoint();

					let polyline = target.points.clear()
				});
				this.viewer.inputHandler.enabled = true;
			} else {
				//this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
				this.viewer.renderer.domElement.addEventListener("mouseup", insertionCallback, false);
				this.viewer.inputHandler.enabled = false;
			}
		}

		clear.callback = e => {
			svg.find("polygon").each((index, target) => {
				let newPoint = svg[0].createSVGPoint();
				let polyline = target.points.clear()
			});
			polyClipVol.removeAllMarkers();
		}

		cancel.callback = e => {
			svg.remove();

			if (polyClipVol.markers.length > 3) {
				polyClipVol.removeLastMarker();
				polyClipVol.initialized = true;
				this.isDone = true;

			} else {
				this.viewer.scene.removePolygonCutFillVolume(polyClipVol);
			}

			this.viewer.renderer.domElement.removeEventListener("mouseup", insertionCallback, false);
			this.viewer.removeEventListener("cancel_insertions", cancel.callback);
			this.viewer.removeEventListener("pause_insertions", pause.callback);
			this.viewer.removeEventListener("clear_insertions", clear.callback);
			this.viewer.inputHandler.enabled = true;

			this.inCutFill = false;
			this.notify();
		};

		this.viewer.addEventListener("cancel_insertions", cancel.callback);
		this.viewer.addEventListener("pause_insertions", pause.callback);
		this.viewer.addEventListener("clear_insertions", clear.callback);
		this.viewer.renderer.domElement.addEventListener("mouseup", insertionCallback, false);
		this.viewer.inputHandler.enabled = false;

		polyClipVol.addMarker();
		this.viewer.inputHandler.startDragging(
			polyClipVol.markers[polyClipVol.markers.length - 1]);

		return polyClipVol;
	}

	update() {

	}
};

function copyMaterial(source, target) {

	for (let name of Object.keys(target.uniforms)) {
		target.uniforms[name].value = source.uniforms[name].value;
	}

	target.gradientTexture = source.gradientTexture;
	target.visibleNodesTexture = source.visibleNodesTexture;
	target.classificationTexture = source.classificationTexture;
	target.matcapTexture = source.matcapTexture;

	target.activeAttributeName = source.activeAttributeName;
	target.ranges = source.ranges;

	//target.updateShaderSource();
}

class Batch {
	constructor(geometry, material) {
		this.geometry = geometry;
		this.material = material;
		this.sceneNode = new THREE.Points(geometry, material);
		this.geometryNode = {
			estimatedSpacing: 1.0,
			geometry: geometry,
		};
	}
	getLevel() {
		return 0;
	}
}

class ClippingFakeOctree extends PointCloudTree {
	constructor(octree) {
		super();
		this.trueOctree = octree;
		this.pcoGeometry = octree.pcoGeometry;
		this.points = [];
		this.visibleNodes = [];
		this.visibleBounds = new THREE.Box3();

		//this.material = this.trueOctree.material;
		this.material = new PointCloudMaterial();
		//this.material.copy(this.trueOctree.material);
		copyMaterial(this.trueOctree.material, this.material);
		this.material.pointSizeType = PointSizeType.FIXED;

		this.batchSize = 100 * 1000;
		this.currentBatch = null

		this.profileRequests = [];

		this.polygonVolumeRequests = [];
		this._visible = true;
	}

	moveTo(pos) {
		this.position.set(pos.x, pos.y, pos.z);
	};

	getAttribute(name) {
		return this.trueOctree.getAttribute(name);
	}

	dispose() {
		for (let node of this.visibleNodes) {
			node.geometry.dispose();
		}
		this.visible = false;
		this.visibleNodes = [];
		this.currentBatch = null;
		this.points = [];
	}

	addPoints(data) {
		// since each call to addPoints can deliver very very few points,
		// we're going to batch them into larger buffers for efficiency.

		if (this.currentBatch === null) {
			this.currentBatch = this.createNewBatch(data);
		}

		this.points.push(data);


		let updateRange = {
			start: this.currentBatch.geometry.drawRange.count,
			count: 0
		};
		//let projectedBox = new THREE.Box3();

		let truePos = new THREE.Vector3();

		for (let i = 0; i < data.numPoints; i++) {

			if (updateRange.start + updateRange.count >= this.batchSize) {
				// current batch full, start new batch

				for (let key of Object.keys(this.currentBatch.geometry.attributes)) {
					let attribute = this.currentBatch.geometry.attributes[key];
					attribute.updateRange.offset = updateRange.start;
					attribute.updateRange.count = updateRange.count;
					attribute.needsUpdate = true;
				}

				this.currentBatch.geometry.computeBoundingBox();
				this.currentBatch.geometry.computeBoundingSphere();

				this.currentBatch = this.createNewBatch(data);
				updateRange = {
					start: 0,
					count: 0
				};
			}

			truePos.set(
				data.data.position[3 * i + 0] + this.trueOctree.position.x,
				data.data.position[3 * i + 1] + this.trueOctree.position.y,
				data.data.position[3 * i + 2] + this.trueOctree.position.z,
			);

			let x = truePos.x;
			let y = truePos.y;
			let z = truePos.z;

			//projectedBox.expandByPoint(new THREE.Vector3(x, y, z));

			let index = updateRange.start + updateRange.count;
			let geometry = this.currentBatch.geometry;

			for (let attributeName of Object.keys(data.data)) {
				let source = data.data[attributeName];
				let target = geometry.attributes[attributeName];
				let numElements = target.itemSize;

				for (let item = 0; item < numElements; item++) {
					target.array[numElements * index + item] = source[numElements * i + item];
				}
			}

			{
				let position = geometry.attributes.position;

				position.array[3 * index + 0] = x;
				position.array[3 * index + 1] = y;
				position.array[3 * index + 2] = z;
			}

			updateRange.count++;
			this.currentBatch.geometry.drawRange.count++;
		}

		for (let key of Object.keys(this.currentBatch.geometry.attributes)) {
			let attribute = this.currentBatch.geometry.attributes[key];
			attribute.updateRange.offset = updateRange.start;
			attribute.updateRange.count = updateRange.count;
			attribute.needsUpdate = true;
		}

		//data.projectedBox = projectedBox;
		//this.projectedBox = this.points.reduce( (a, i) => a.union(i.projectedBox), new THREE.Box3());
	}

	createNewBatch(data) {
		let geometry = new THREE.BufferGeometry();

		// create new batches with batch_size elements of the same type as the attribute
		for (let attributeName of Object.keys(data.data)) {
			let buffer = data.data[attributeName];
			let numElements = buffer.length / data.numPoints; // 3 for pos, 4 for col, 1 for scalars
			let constructor = buffer.constructor;
			let normalized = false;

			if (this.trueOctree.root.sceneNode) {
				if (this.trueOctree.root.sceneNode.geometry.attributes[attributeName]) {
					normalized = this.trueOctree.root.sceneNode.geometry.attributes[attributeName].normalized;
				}
			}


			let batchBuffer = new constructor(numElements * this.batchSize);

			let bufferAttribute = new THREE.BufferAttribute(batchBuffer, numElements, normalized);
			bufferAttribute.potree = {
				range: [0, 1],
			};

			geometry.setAttribute(attributeName, bufferAttribute);
		}

		geometry.drawRange.start = 0;
		geometry.drawRange.count = 0;

		let batch = new Batch(geometry, this.material);

		this.visibleNodes.push(batch);

		return batch;
	}

	computeVisibilityTextureData() {
		let data = new Uint8Array(this.visibleNodes.length * 4);
		let offsets = new Map();

		for (let i = 0; i < this.visibleNodes.length; i++) {
			let node = this.visibleNodes[i];

			offsets[node] = i;
		}


		return {
			data: data,
			offsets: offsets,
		};
	}

	updateVisibleBounds() {
	}

	pick(viewer, camera, ray, params = {}) {
		return null;
	}

	/**
	 * Updates the material properties based on the current state of the point cloud.
	 *
	 * @param {PointCloudMaterial} material - The point cloud material to update.
	 * @param {PointCloudTreeNode[]} visibleNodes - Array of currently visible nodes.
	 * @param {THREE.Camera} camera - The camera used for rendering.
	 * @param {THREE.WebGLRenderer} renderer - The renderer used for rendering.
	 */
	updateMaterial(material, visibleNodes, camera, renderer) {
		material.fov = camera.fov * (Math.PI / 180);
		material.screenWidth = renderer.domElement.clientWidth;
		material.screenHeight = renderer.domElement.clientHeight;
		material.spacing = this.pcoGeometry.spacing; // * Math.max(this.scale.x, this.scale.y, this.scale.z);
		material.near = camera.near;
		material.far = camera.far;
		material.uniforms.octreeSize.value = this.pcoGeometry.boundingBox.getSize(new THREE.Vector3()).x;
	}
	get visible() {
		return this._visible;
	}
	/**
	 * Sets the visibility status of the point cloud.
	 *
	 * @param {boolean} value - The visibility status to set.
	 */
	set visible(value) {

		if (value !== this._visible) {
			this._visible = value;

			this.dispatchEvent({ type: 'visibility_changed', pointcloud: this });
		}

	}

	get pointBudget() {
		return this.points.length;
	}
}

const Status = Object.freeze({
	NONE: 'none',
	START: 'start',
	RUNNING: 'running',
	DONE: 'done',
	FAILED: 'failed',
});

export class ClippingController extends EventDispatcher {

	constructor(viewer) {
		super();
		this.viewer = viewer;
		this.totalPoints = 0;
		this.numPoints = 0;
		this.threshold = 60 * 1000;
		this.enabled = true;
		this.pointcloudsInside = new Map();
		this.pointcloudsOutside = new Map();
		this.requests = [];
		// this._recompute = () => { this.recompute(); };
		// this.viewer.addEventListener("scene_changed", e => {
		// 	e.oldScene.removeEventListener("pointcloud_added", this._recompute);
		// 	e.scene.addEventListener("pointcloud_added", this._recompute);
		// });
		// this.viewer.scene.addEventListener("pointcloud_added", this._recompute);
		this.addEventListener("cancel_clipping", this.cancel)
		this.status = Status.NONE

	}


	notify(status) {
		if (status) this.status = status;
		let progress = this.totalPoints === 0 ? 0 : this.numPoints * 100 / this.totalPoints
		progress = progress.toFixed(0);
		//console.log("progress = ", progress)
		const data = {
			status: this.status,
			progress: progress,

		}

		if (status == Status.DONE) {
			//data.oriPointCloud = this.pointcloud
			data.pointcloudsInside = this.pointcloudsInside
			data.pointcloudsOutside = this.pointcloudsOutside
		}

		const event = new CustomEvent('onClippingStatusNotify', { detail: data });
		window.dispatchEvent(event);
	}

	appendPoints(pointcloud, insidePoints, outsidePoints) {
		if (insidePoints.numPoints > 0) {
			let entryInside = this.pointcloudsInside.get(pointcloud);
			if (!entryInside) {
				entryInside = new ClippingFakeOctree(pointcloud);
				this.pointcloudsInside.set(pointcloud, entryInside);
				// todo
				//this.viewer.scene.add(entryInside);
				entryInside.moveTo(pointcloud.position);
				console.log(entryInside);
				entryInside.visible = false;
				this.viewer.scene.addPointCloud(entryInside);
			}
			entryInside.addPoints(insidePoints);

		}
		if (outsidePoints.numPoints > 0) {
			let entryOutside = this.pointcloudsOutside.get(pointcloud);
			if (!entryOutside) {
				entryOutside = new ClippingFakeOctree(pointcloud);
				this.pointcloudsOutside.set(pointcloud, entryOutside);
				// todo
				//this.viewer.scene.add(entryOutside);
				entryOutside.moveTo(pointcloud.position);
				console.log(entryOutside);
				entryOutside.visible = false;
				this.viewer.scene.addPointCloud(entryOutside);
			}
			entryOutside.addPoints(outsidePoints);
		}
	}

	progressHandler(pointcloud, insidePoints, outsidePoints) {
		this.appendPoints(pointcloud, insidePoints, outsidePoints);
		this.numPoints += (insidePoints.numPoints + outsidePoints.numPoints);
		this.notify(Status.RUNNING);
	}

	reset() {
		this.status = Status.NONE;
		this.numPoints = 0;
		this.totalPoints = 0;
		if (this.pointcloudsOutside) {
			for (let [key, entry] of this.pointcloudsOutside) {
				entry.visible = false;
				entry.dispose();
			}
			this.pointcloudsOutside.clear();
			//this.pointcloudsOutside = new Map();
		}
		if (this.pointcloudsInside) {
			for (let [key, entry] of this.pointcloudsInside) {
				entry.visible = false;
				entry.dispose();
			}
			this.pointcloudsInside.clear();
			//this.pointcloudsInside = new Map();
		}
		if (this.requests) {
			for (let request of this.requests) {
				request.cancel();
			}
			//	this.requests = [];
		}
	}

	cancel() {
		this.status = Status.NONE;
		this.notify(Status.NONE);
		this.numPoints = 0;
		this.totalPoints = 0;
		if (this.pointcloudsOutside) {
			for (let [key, entry] of this.pointcloudsOutside) {
				entry.dispose();
			}
			this.pointcloudsOutside.clear();
			//this.pointcloudsOutside = new Map();
		}
		if (this.pointcloudsInside) {
			for (let [key, entry] of this.pointcloudsInside) {
				entry.dispose();
			}
			this.pointcloudsInside.clear();
			//this.pointcloudsInside = new Map();
		}
		for (let request of this.requests) {
			request.cancel();
			// request.finishLevelThenCancel();
		}
		this.requests = [];


	};

	finishLevelThenCancel() {
		for (let request of this.requests) {
			request.finishLevelThenCancel();
		}
		this.requests = [];
	}

	clip(pointcloud) {
		this.pointcloud = pointcloud;
		const polygonVolume = pointcloud.material.clipPolygons;
		//let points = new Points();
		//let outPoints = new Points();
		if (polygonVolume.length > 0) {
			this.reset();
			this.totalPoints = pointcloud.pointBudget;
			console.log("totalPoint = ", this.totalPoints)
			this.notify(Status.START);
			let request = pointcloud.getPointsInPolygonVolume(polygonVolume[0], this.viewer, null, null, {
				'onProgress': (event) => {
					if (!this.enabled) {
						return;
					}
					this.progressHandler(pointcloud, event.insidePoints, event.outsidePoints);
				},
				'onFinish': (event) => {
					this.notify(Status.DONE);
					if (!this.enabled) {
					}
				},
				'onCancel': () => {
					//this.notify(Status.NONE);
					if (!this.enabled) {
					}
				}
			});
			this.requests.push(request);
		}
	}

};

export class CutFillController extends EventDispatcher {

	constructor(viewer) {
		super();
		this.viewer = viewer;
		this.totalPoints = 0;
		this.numPoints = 0;
		this.threshold = 60 * 1000;
		this.enabled = true;
		// this.pointcloudsInside = new Map();
		// this.pointcloudsOutside = new Map();
		this.minHeight = Number.POSITIVE_INFINITY;
		this.maxHeight = Number.NEGATIVE_INFINITY;

		this.points = new Points();



		this.requests = [];

		this.addEventListener("cancel_cut_fill", this.cancelCutFill)
		this.status = Status.NONE
		this.totalPointsInIntersectNodes = 0;
	}

	getDist(id_a, id_b) {
		const ax = this.tempPoints.data.position[3 * id_a + 0];
		const ay = this.tempPoints.data.position[3 * id_a + 1];
		const bx = this.tempPoints.data.position[3 * id_b + 0];
		const by = this.tempPoints.data.position[3 * id_b + 1];
		return Math.sqrt((ax - bx) * (ax - bx) + (ay - by) * (ay - by));
	}

	getMinDist(left, right) {
		let length = right - left + 1;

		if (length == 2) return this.getDist(left, right);
		if (length == 3)
			return Math.min(Math.min(this.getDist(left, left + 1), this.getDist(left + 1, right)), this.getDist(left, right));

		let mid = Math.floor((left + right) / 2);

		/*这里的区域点对最小距离是递归获取到的 命令式同步编程 等待d的返回 再走下一步*/
		let dis = Math.min(this.getMinDist(left, mid), this.getMinDist(mid + 1, right));

		/*在这里 我们一次性做两个操作 获取左边的点后 我们直接去和右边的点比较 */
		for (let i = mid; i >= left; i--) { // 为什么这里可以这么写？因为我们前面已经根据X左边来从小到大排序了 我们将边界点划给左边
			const mx = this.tempPoints.data.position[3 * mid + 0];
			const ix = this.tempPoints.data.position[3 * i + 0];
			const iy = this.tempPoints.data.position[3 * i + 1];
			if (mx - ix <= dis) { // 如果这个点是右边的 则开始和右边比较
				for (let j = mid + 1; j <= right; j++) { // 向右边搜索 属于右边区域的点
					const jx = this.tempPoints.data.position[3 * j + 0];
					const jy = this.tempPoints.data.position[3 * j + 1];
					if (jx - mx && Math.abs(jy - iy) <= dis) { // 属于右边边界 并且与左边正在比较的点的纵坐标相差小于等于dis
						dis = Math.min(this.getDist(i, j), dis);
					}
				}
			}
		}

		/*返回一个最小dis*/
		return dis;
	}

	findCloseDistance() {
		return this.getMinDist(0, this.tempPoints.numPoints - 1);
	}

	notify(status, process = null) {
		if (status) this.status = status;
		let progress = this.totalPoints === 0 ? 0 : this.numPoints * 100 / this.totalPoints;
		console.log(progress);
		if (process !== null)
			progress = process;
		if (progress * 5 < 99) {
			progress = progress * 5;
		} else if (progress * 5 > 99) progress = 99;

		progress = progress.toFixed(0);
		//console.log("progress = ", progress)
		const data = {
			status: this.status,
			progress: progress,
		}

		if (status == Status.DONE) {
			data.minHeight = this.minHeight
			data.maxHeight = this.maxHeight
			data.fitHeight = this.fitHeight
		}

		const event = new CustomEvent('onCutFillStatusNotify', { detail: data });
		window.dispatchEvent(event);
	}

	appendPoints(pointcloud, insidePoints) {
		this.points.add(insidePoints);
	}

	updateMinMax(pointCloud, insidePoints) {
		let box = insidePoints.boundingBox;
		this.minHeight = Math.min(box.min.z, this.minHeight);
		this.maxHeight = Math.max(box.max.z, this.maxHeight);
	}

	progressHandler(pointcloud, insidePoints, outsidePoints, totalPointsInIntersectNodes) {
		this.appendPoints(pointcloud, insidePoints)
		this.updateMinMax(pointcloud, insidePoints);
		this.numPoints += (insidePoints.numPoints + outsidePoints.numPoints);
		if (this.totalPointsInIntersectNodes === 0) {
			this.totalPointsInIntersectNodes = totalPointsInIntersectNodes * 16;// 估值
		}
		this.notify(Status.RUNNING);
	}

	reset() {
		this.status = Status.NONE;
		this.numPoints = 0;
		this.totalPoints = 0;
		this.minHeight = Number.POSITIVE_INFINITY;
		this.maxHeight = Number.NEGATIVE_INFINITY;
		this.points = new Points();

		if (this.requests) {
			for (let request of this.requests) {
				request.cancel();
			}
		}
	}

	cancelCutFill() {
		this.cancel();
		this.viewer.cutFillTool.cancelCutFill();
	}

	cancel() {
		this.status = Status.NONE;
		this.notify(Status.NONE);
		this.numPoints = 0;
		this.totalPoints = 0;
		this.minHeight = Number.POSITIVE_INFINITY;
		this.maxHeight = Number.NEGATIVE_INFINITY;

		this.points = new Points();

		for (let request of this.requests) {
			request.cancel();
		}
		this.requests = [];
	};

	finishLevelThenCancel() {
		for (let request of this.requests) {
			request.finishLevelThenCancel();
		}
		this.requests = [];
	}

	calcMedium() {
		let sum = 0;
		for (let i = 0; i < this.points.numPoints; ++i) {
			sum += this.points.data.position[3 * i + 2];
		}
		this.fitHeight = sum / this.points.numPoints;
	}

	calcRange(pointcloud) {
		this.pointcloud = pointcloud;
		const polygonVolume = pointcloud.material.clipPolygons;
		//let points = new Points();
		//let outPoints = new Points();

		if (polygonVolume.length > 0) {
			this.reset();
			this.totalPoints = pointcloud.pointBudget;
			console.log("totalPoint = ", this.totalPoints)
			this.notify(Status.START);
			let request = pointcloud.getPointsInPolygonVolume(polygonVolume[0], this.viewer, true, null, {
				'onProgress': (event) => {
					if (!this.enabled) {
						return;
					}
					this.progressHandler(pointcloud, event.insidePoints, event.outsidePoints, event.totalPointsInIntersectNodes);
				},
				'onFinish': (event) => {
					this.notify(Status.RUNNING, 99);
					this.calcMedium();

					this.notify(Status.DONE);
					if (!this.enabled) {
					}
				},
				'onCancel': () => {
					//this.notify(Status.NONE);
					if (!this.enabled) {
					}
				}
			});
			this.requests.push(request);
		}
	}


	async compute(step, baseHeight) {
		let minX = this.points.boundingBox.min.x;
		let maxX = this.points.boundingBox.max.x;
		let minY = this.points.boundingBox.min.y;
		let maxY = this.points.boundingBox.max.y;
		let minZ = this.points.boundingBox.min.z;
		let maxZ = this.points.boundingBox.max.z;

		console.log(minX)
		console.log(maxX)
		console.log(minY)
		console.log(maxY)
		console.log(minZ)
		console.log(maxZ)

		let numX = Math.ceil((maxX - minX) / step)
		let numY = Math.ceil((maxY - minY) / step)
		let numZ = Math.ceil((maxZ - minZ) / step)

		let data = new Map();

		let projArea = 0;
		let cutArea = 0;
		let fillArea = 0;
		let cutVol = 0;
		let fillVol = 0;
		let allVol = 0;

		console.log(this.points);

		let dataXZ = new Map();

		let dataYZ = new Map();

		for (let n = 0; n < this.points.numPoints; ++n) {
			let point = new THREE.Vector3();
			point.x = this.points.data.position[3 * n + 0];
			point.y = this.points.data.position[3 * n + 1];
			point.z = this.points.data.position[3 * n + 2];
			//console.log(point)

			let i = Math.round((point.x - minX) / step);
			let j = Math.round((point.y - minY) / step);

			let i1 = i;
			let j1 = Math.round((point.z - minZ) / step);

			let i2 = j;
			let j2 = j1;

			// dataXY
			if (data.has(i)) {
				if (data.get(i).has(j)) {
					data.get(i).get(j).push(point.z);
				} else {
					let arr = new Array();
					arr.push(point.z)
					data.get(i).set(j, arr);
				}
			} else {
				let row = new Map();
				let arr = new Array();
				arr.push(point.z);
				row.set(j, arr);
				data.set(i, row);
			}


			// dataXZ
			if (dataXZ.has(i1)) {
				if (dataXZ.get(i1).has(j1)) {
					dataXZ.get(i1).get(j1).push(point.y);
				} else {
					let arr = new Array();
					arr.push(point.y)
					dataXZ.get(i1).set(j1, arr);
				}
			} else {
				let row = new Map();
				let arr = new Array();
				arr.push(point.y);
				row.set(j1, arr);
				dataXZ.set(i1, row);
			}

			// dataYZ
			if (dataYZ.has(i2)) {
				if (dataYZ.get(i2).has(j2)) {
					dataYZ.get(i2).get(j2).push(point.x);
				} else {
					let arr = new Array();
					arr.push(point.x)
					dataYZ.get(i2).set(j2, arr);
				}
			} else {
				let row = new Map();
				let arr = new Array();
				arr.push(point.x);
				row.set(j2, arr);
				dataYZ.set(i2, row);
			}
		}

		// 数据插值
		// 由于激光雷达分辨率原因，两个点云之间的分辨率可能不高，
		// 所以为了消除误差，除了当前格点step，还引入了点云之间的最小距离eps
		// 检测eps范围内是否存在点，如果存在，会一起统计表面积和体积，保证连续性
		const eps = 0.06;
		const eps_grid = Math.round(eps / step);

		let unit = step * step;

		let count = 0;

		let rn = 0;

		//console.log('' +numAll);
		const section = 1000000;
		const grpXY = Math.ceil(numX * numY / section);
		let bits = new Array(grpXY);
		for (let i = 0; i < grpXY; ++i) {
			bits[i] = new Array(section).fill(false);
		}
		//let bits = new Array(numAll).fill(false);
		//console.log(bits)

		for (let [i, row] of data) {
			//console.log("omgomg rn = " + rn + '/' + numX);
			rn++;
			for (let [j, arr] of row) {

				//let arr = data.get(fi).get(fj);
				let max = Math.max(...arr);
				let min = Math.min(...arr);

				for (let ii = 0; ii < eps_grid; ++ii) {
					for (let jj = 0; jj < eps_grid; ++jj) {
						let ni = i + ii;
						let nj = j + jj;
						//ni = Math.max(0, ni)
						ni = Math.min(numX - 1, ni)
						//nj = Math.max(0, nj)
						nj = Math.min(numY - 1, nj)

						const idx = ni * numY + nj;
						const grp = Math.floor(idx / section);
						const id = idx % section;
						let isEmpty = !bits[grp][id];

						if (isEmpty) {
							projArea += unit;
							// cut 
							if (max > baseHeight) {
								cutArea += unit;
								cutVol += unit * (max - baseHeight);
								allVol += unit * (max - baseHeight);
							}
							// fill
							if (min < baseHeight) {
								fillArea += unit;
								fillVol += unit * (baseHeight - min);
								allVol += unit * (baseHeight - min);
							}
							count++;
							//bits[ni *numY + nj] = true;
							bits[grp][id] = true
						}
					}
				}
			}
		}

		// XZ plane
		const numXZ = numX * numZ;
		const grpXZ = Math.ceil(numXZ / section);
		bits = new Array(grpXZ);
		for (let i = 0; i < grpXZ; ++i) {
			bits[i] = new Array(section).fill(false);
		}
		rn = 0;
		for (let [i, row] of dataXZ) {
			//console.log("omgomg rn = " + rn +'/' + numX);
			rn++;
			for (let [j, arr] of row) {
				//let arr = data.get(fi).get(fj);
				// let max = Math.max(...arr);
				// let min = Math.min(...arr);
				let len = arr.length;
				let height = j * step + minZ;
				for (let ii = 0; ii < eps_grid; ++ii) {
					for (let jj = 0; jj < eps_grid; ++jj) {
						let ni = i + ii;
						let nj = j + jj;
						//ni = Math.max(0, ni)
						ni = Math.min(numX - 1, ni)
						//nj = Math.max(0, nj)
						nj = Math.min(numZ - 1, nj)

						const idx = ni * numZ + nj;
						const grp = Math.floor(idx / section);
						const id = idx % section;
						let isEmpty = !bits[grp][id];

						if (isEmpty) {
							// cut 
							if (height > baseHeight) {
								cutArea += unit * len;
								// fill
							} else {
								fillArea += unit * len;
							}
							bits[grp][id] = true
						}
					}
				}
			}
		}


		// YZ plane
		const numYZ = numY * numZ;
		const grpYZ = Math.ceil(numYZ / section);
		bits = new Array(grpYZ);
		for (let i = 0; i < grpYZ; ++i) {
			bits[i] = new Array(section).fill(false);
		}
		rn = 0;
		for (let [i, row] of dataYZ) {
			//console.log("omgomg rn = " + rn + '/' + numY );
			rn++;
			for (let [j, arr] of row) {
				let len = arr.length;
				let height = j * step + minZ;
				for (let ii = 0; ii < eps_grid; ++ii) {
					for (let jj = 0; jj < eps_grid; ++jj) {
						let ni = i + ii;
						let nj = j + jj;
						//ni = Math.max(0, ni)
						ni = Math.min(numY - 1, ni)
						//nj = Math.max(0, nj)
						nj = Math.min(numZ - 1, nj)

						const idx = ni * numZ + nj;
						const grp = Math.floor(idx / section);
						const id = idx % section;
						let isEmpty = !bits[grp][id];

						if (isEmpty) {
							// cut 
							if (height > baseHeight) {
								cutArea += unit * len;
								// fill
							} else {
								fillArea += unit * len;
							}
							bits[grp][id] = true
						}
					}
				}
			}
		}

		console.log("numX = " + numX)
		console.log("numY = " + numY)
		console.log("numZ = " + numY)
		console.log("step = " + step)
		console.log("unit = " + unit)
		console.log("count point = " + count);
		console.log("all points = " + this.points.numPoints);
		console.log([projArea, cutArea, fillArea, cutVol, fillVol, allVol]);

		return Promise.resolve([projArea, cutArea, fillArea, cutVol, fillVol, allVol]);

	}

};